import { render, staticRenderFns } from "./wtAssetActions.vue?vue&type=template&id=dec79014&"
import script from "./wtAssetActions.vue?vue&type=script&lang=js&"
export * from "./wtAssetActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports